import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    Typography,
    Button,
    FormControlLabel,
    Checkbox,
    Paper,
    Chip,
    Grid,
} from "@mui/material";
import axios from "axios";
import authService from "../Auth/AuthService";

export default function AddSubscriptionPlan({ planId, onSuccess }) {
    const [plan, setPlan] = useState({
        id: "",
        name: "",
        currency: "INR",
        price: "",
        durationInDays: "",
        description: "",
        active: false,
        stdCount: "",
        features: [],
        coupons: "",
    });

    const [featureInput, setFeatureInput] = useState("");
    const [isEdit, setIsEdit] = useState(false);

    // Load plan if planId provided (for update)
    useEffect(() => {
        if (planId) {
            setIsEdit(true);
            setPlan(planId)
            // fetchPlan(planId);
        }
    }, [planId]);

    const fetchPlan = async (id) => {
        try {
            const res = await axios.get(`http://localhost:8080/api/subscription-plans/${id}`);
            setPlan({
                ...res.data,
                coupons: res.data.coupons?.id || "",
            });
        } catch (err) {
            console.error("Error fetching plan:", err);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setPlan((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const addFeature = () => {
        if (featureInput.trim() !== "") {
            setPlan((prev) => ({
                ...prev,
                features: [...prev.features, featureInput],
            }));
            setFeatureInput("");
        }
    };

    const removeFeature = (index) => {
        setPlan((prev) => ({
            ...prev,
            features: prev.features.filter((_, i) => i !== index),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const url = authService.pathUrl("POST/PUT", "/subscription/plans");
            if (isEdit) {
                await authService.putAuth(url + `/${plan.id}`, plan);
                alert("Subscription Plan Updated Successfully!");
                // window.location.reload();
            } else {
                await authService.postAuth(url, plan);
                alert("Subscription Plan Added Successfully!");
            }
            if (onSuccess) onSuccess();
        } catch (err) {
            console.error(err);
            alert("Error saving plan");
        }
    };

    return (
        <Box sx={{ maxWidth: 600, mx: "auto", px: 2 }}>
            <form onSubmit={handleSubmit}>
                <Box display={'flex'} flexWrap={'wrap'} justifyContent={'space-between'}>
                    <Grid sx={{ width: '240px' }}>
                        <TextField
                            fullWidth
                            label="Plan Name"
                            name="name"
                            value={plan.name}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                        {/* </Grid><Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Currency"
                            name="currency"
                            value={plan.currency}
                            onChange={handleChange}
                            margin="normal"
                        /> */}
                    </Grid><Grid sx={{ width: '240px' }}>
                        <TextField
                            fullWidth
                            label="Price"
                            type="number"
                            name="price"
                            value={plan.price}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                    </Grid><Grid sx={{ width: '240px' }}>
                        <TextField
                            fullWidth
                            label="Duration (Days)"
                            type="number"
                            name="durationInDays"
                            value={plan.durationInDays}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                    </Grid><Grid sx={{ width: '240px' }}>
                        <TextField
                            fullWidth
                            label="Max Student Count"
                            type="number"
                            name="stdCount"
                            value={plan.stdCount}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                    </Grid>
                    <Grid sx={{ width: '240px' }}>
                        <TextField
                            fullWidth
                            label="Plan Type(School/Church)"
                            type="text"
                            name="planType"
                            value={plan.planType}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                    </Grid><Grid sx={{ width: '240px' }}>
                        <TextField
                            fullWidth
                            label="Max Employee Count"
                            type="number"
                            name="empCount"
                            value={plan.empCount}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />
                    </Grid>
                </Box>
                <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={plan.description}
                    onChange={handleChange}
                    margin="normal"
                    multiline
                    rows={2}
                />
                {/* Features */}
                <Typography mt={2} mb={1} fontWeight="bold">
                    Features
                </Typography>
                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                    <TextField
                        label="Add Feature"
                        value={featureInput}
                        onChange={(e) => setFeatureInput(e.target.value)}
                        size="small"
                        fullWidth
                    />
                    <Button variant="contained" onClick={addFeature} sx={{ bgcolor: '#1b1914' }}>
                        Add
                    </Button>
                </Box>

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                    {plan.features.map((f, i) => (
                        <Chip key={i} label={f} onDelete={() => removeFeature(i)} color="warning" />
                    ))}
                </Box>

                {/* <TextField
                    fullWidth
                    label="Coupon ID"
                    name="coupons"
                    value={plan.coupons}
                    onChange={handleChange}
                    margin="normal"
                /> */}

                <FormControlLabel
                    control={
                        <Checkbox checked={plan.active} onChange={handleChange} name="active" />
                    }
                    label="Active"
                />
                <FormControlLabel
                    control={
                        <Checkbox unchecked={plan.popular} onChange={handleChange} name="popular" />
                    }
                    label="Popular"
                />

                <Button
                    type="submit"
                    variant="contained"
                    color={isEdit ? "success" : "primary"}
                    fullWidth
                    sx={{ mt: 2, bgcolor: '#1b1914', borderRadius: 5 }}
                >
                    {isEdit ? "Update Plan" : "Save Plan"}
                </Button>
            </form>
        </Box>
    );
}
